const { useTranslation } = require("react-i18next");

const useTranslate = (key) => {
  const { t } = useTranslation();
  return t(key, { returnObjects: true });
};

export default useTranslate;
